(function () {
  'use strict';

  const productGrid = document.getElementById('product-grid');
  const loader = document.getElementById('InfiniteScrollLoader');
  if (!productGrid || !loader) return;
  if (productGrid.dataset.infiniteScroll !== 'true') return;

  let page = 2; // następna strona do pobrania
  const maxPages = Number(loader.getAttribute('data-max-pages')) || 1;

  let loading = false;
  let ended = false;

  const rootMargin = '4000px 0px 4000px 0px'; // wcześniej startuje
  const TIMEOUT_MS = 20000;

  // Prefetch cache: pageNumber -> Promise<string(html)>
  const prefetch = new Map();

  window.__INF_SCROLL__ = window.__INF_SCROLL__ || {};
  window.__INF_SCROLL__.getLoadedPage = () => Math.max(1, page - 1);

  if (maxPages <= 1 || page > maxPages) {
    loader.style.display = 'none';
    ended = true;
    return;
  }

  const nextUrl = (p) => {
    const url = new URL(window.location.href);
    url.searchParams.set('page', p);
    return url.toString();
  };

  const allowedNodes = (doc) => {
    const container = doc.getElementById('ProductGridContainer');
    if (!container) return [];
    const newGrid = container.querySelector('#product-grid');
    if (!newGrid) return [];
    const nodes = newGrid.querySelectorAll('li.grid__item');
    return Array.from(nodes).filter(node => !node.classList.contains('promo-block-item'));
  };

  const refreshVisuals = () => {
    try {
      if (window.Shopify?.Image?.lazyload) Shopify.Image.lazyload();
      if (typeof initializeScrollAnimationTrigger === 'function') {
        const newItems = productGrid.querySelectorAll('.grid__item');
        newItems.forEach(item => initializeScrollAnimationTrigger(item.outerHTML));
      }
    } catch (e) {}
  };

  function finish() {
    ended = true;
    loading = false;
    loader.classList.remove('is-loading');
    loader.style.display = 'none';
    try { observer.unobserve(loader); } catch (e) {}
  }

  function startPrefetch(p) {
    if (ended) return;
    if (p > maxPages) return;
    if (prefetch.has(p)) return;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);

    const prom = fetch(nextUrl(p), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      signal: controller.signal
    })
      .then(r => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .finally(() => clearTimeout(timeoutId));

    prefetch.set(p, prom);
  }

  async function fetchHtml(p) {
    // Jeśli mamy już pobrane -> użyj
    if (prefetch.has(p)) {
      const prom = prefetch.get(p);
      prefetch.delete(p);
      return await prom;
    }
    // fallback: pobierz normalnie
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);
    try {
      const res = await fetch(nextUrl(p), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        signal: controller.signal
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return await res.text();
    } finally {
      clearTimeout(timeoutId);
    }
  }

  async function loadMore() {
    if (loading || ended) return false;
    if (page > maxPages) { finish(); return false; }

    loading = true;
    loader.classList.add('is-loading');
    try { observer.unobserve(loader); } catch (e) {}

    try {
      const html = await fetchHtml(page);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = allowedNodes(doc);

      if (!items.length) { finish(); return false; }

      items.forEach(item => productGrid.appendChild(item.cloneNode(true)));
      refreshVisuals();

      page++;
      window.__INF_SCROLL__.getLoadedPage = () => Math.max(1, page - 1);

      if (page > maxPages) { finish(); return false; }

      // 🚀 prefetch kolejnej strony natychmiast po doładowaniu
      startPrefetch(page);

      return true;
    } catch (e) {
      loader.innerHTML =
        '<span style="opacity:.7">Ładowanie nie powiodło się. <button type="button" class="infinite-retry" style="text-decoration:underline;cursor:pointer;background:none;border:none;color:inherit;">Spróbuj ponownie</button></span>';

      const retryBtn = loader.querySelector('.infinite-retry');
      if (retryBtn) {
        retryBtn.addEventListener('click', () => {
          loader.innerHTML = '<span class="spinner" aria-hidden="true"></span><span class="sr-only">Ładowanie…</span>';
          loadMore();
        }, { once: true });
      }
      return false;
    } finally {
      loading = false;
      loader.classList.remove('is-loading');
      if (!ended) {
        try { observer.observe(loader); } catch (e) {}
      }
    }
  }

  window.__INF_SCROLL__.loadNext = () => loadMore();

  function onIntersect(entries) {
    if (!entries[0].isIntersecting) return;

    // 🚀 gdy zbliżasz się do dołu — odpal prefetch od razu
    startPrefetch(page);

    loadMore();
  }

  const observer = new IntersectionObserver(onIntersect, { rootMargin });
  observer.observe(loader);

  // 🚀 prefetch strony 2 od razu po starcie
  startPrefetch(page);
})();
